import styles from "./StatisticsReservationDialog.module.scss";
import { IStatisticDetailedItemViewModel } from "../models/statisticDetailedItemViewModel";
import {
  PaymentTypesLabels,
  StatisticDetailItemType,
} from "../../../common/labels";
import { dateUtility } from "../../../common/infrastructure/utilities/dateUtility";
import { StatisticsDialogKeyValueItem } from "./StatisticsDialogKeyValueItem";
import { PriceDisplay } from "../../../common/components/PriceDisplay/PriceDisplay";

interface IStatisticsGymVisitDialogProps {
  item: IStatisticDetailedItemViewModel;
}

/**
 * Drill-down dialog for a single gym visit row in the Money statistic. Mirrors
 * StatisticsReservationDialog but without click-through navigation — gym visits
 * have no dedicated detail page (the gym page is operational, not historical).
 */
export const StatisticsGymVisitDialog = ({
  item,
}: IStatisticsGymVisitDialogProps) => {
  // Payment types where we receive money directly should display the currency
  // symbol next to the label (matches reservation dialog behaviour).
  // The currency is no longer appended here — the amount itself carries it.
  const paymentTypeLabel = item.paymentType
    ? PaymentTypesLabels[item.paymentType]
    : "Неплатено";

  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <div className={styles.root_header_left}>
          <h5>
            {item.userName} <span>(#{item.userId})</span>
          </h5>
          <p>
            Дата на влизане:{" "}
            <span>{dateUtility.formatDateTime(item.dateTime)}</span>
          </p>
        </div>
      </div>

      <div className={styles.root_content}>
        <StatisticsDialogKeyValueItem
          name={"ПЛАТЕНА СУМА"}
          value={
            !!item.pricePaid ? (
              <PriceDisplay
                minPrice={item.pricePaid}
                currencyId={item.currencyId}
              />
            ) : (
              "Неплатено"
            )
          }
        />
        <StatisticsDialogKeyValueItem
          name={"НАЧИН НА ПЛАЩАНЕ"}
          value={paymentTypeLabel}
        />
        <StatisticsDialogKeyValueItem
          name={"СКАНИРАН ОТ"}
          value={item.additionalTypeInfo ?? "—"}
        />
        <StatisticsDialogKeyValueItem
          name={"ТИП ТРАНЗАКЦИЯ"}
          value={StatisticDetailItemType[item.type]}
        />
      </div>
    </div>
  );
};
